(function () {
    'use strict';

    angular
        .module('skillsApp')
        .controller('ImportExportExaminerAssignmentsDialogController', ImportExportExaminerAssignmentsDialogController);

    function ImportExportExaminerAssignmentsDialogController(logger, $uibModalInstance, $translate, identity, isImport, dataService) {
        var vm = this;

        vm.identity = { idString: identity.idString, name: identity.displayName };
        vm.isImport = isImport;

        vm.examiners = [];
        vm.removeExistingAssignments = false;

        vm.cancel = cancel;
        
        vm.identitySelected = identitySelected;
        vm.ok = ok;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }

        function identitySelected(identity) {
            var existing = _.find(vm.examiners, { idString: identity.idString });
            if (existing) return;
            vm.examiners.push({ idString: identity.idString, name: identity.displayName });
        }

        function ok() {
            if (vm.isImport) {
                dataService.importExaminerAssignments(vm.identity, vm.examiners, vm.removeExistingAssignments).then(() => {
                    $uibModalInstance.close();
                });
            }
            else {
                dataService.exportExaminerAssignments(vm.identity, vm.examiners, vm.removeExistingAssignments).then(() => {
                    $uibModalInstance.close();
                });
            }
        }
    }
})();
